const API_URL = import.meta.env.VITE_API_URL || 'http://localhost:5000/api'

export interface LoginResponse {
  success: boolean
  message?: string
  data?: {
    token: string
    email: string
    role: string
  }
  error?: string
}

export interface VerifyResponse {
  success: boolean
  data?: {
    email: string
    role: string
    valid: boolean
  }
  error?: string
}

class AuthService {
  private token: string | null = null

  constructor() {
    // Load token from localStorage on initialization
    this.token = localStorage.getItem('admin-token')
  }

  async login(email: string, password: string): Promise<LoginResponse> {
    try {
      const response = await fetch(`${API_URL}/auth/admin/login`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({ email, password }),
      })

      const data: LoginResponse = await response.json()

      if (data.success && data.data?.token) {
        this.token = data.data.token
        localStorage.setItem('admin-token', this.token)
        localStorage.setItem('admin-authenticated', 'true')
      }

      return data
    } catch (error) {
      return {
        success: false,
        error: 'Verbindungsfehler. Bitte versuchen Sie es später erneut.'
      }
    }
  }

  async verifyToken(): Promise<VerifyResponse> {
    if (!this.token) {
      return {
        success: false,
        error: 'Kein Token vorhanden'
      }
    }

    try {
      const response = await fetch(`${API_URL}/auth/admin/verify`, {
        method: 'GET',
        headers: {
          'Authorization': `Bearer ${this.token}`,
          'Content-Type': 'application/json',
        },
      })

      const data: VerifyResponse = await response.json()

      if (!data.success) {
        this.logout()
      }

      return data
    } catch (error) {
      this.logout()
      return {
        success: false,
        error: 'Token-Verifikation fehlgeschlagen'
      }
    }
  }

  logout(): void {
    this.token = null
    localStorage.removeItem('admin-token')
    localStorage.removeItem('admin-authenticated')
  }

  getToken(): string | null {
    return this.token
  }

  isAuthenticated(): boolean {
    return this.token !== null && localStorage.getItem('admin-authenticated') === 'true'
  }

  getAuthHeader(): { Authorization: string } | {} {
    if (this.token) {
      return { Authorization: `Bearer ${this.token}` }
    }
    return {}
  }
}

// Create singleton instance
const authService = new AuthService()
export default authService